'use client'
import { useTranslations } from 'next-intl'
import AppLink, { AppLinkSize } from '../UI/Links/AppLink/AppLink'
import { useUserStore } from '@/stores/useUserStore'

export default function FooterUnsubscribeExternalLogout () {
  const t = useTranslations('Footer')
  const { userId, profileId} = useUserStore()

  if (!userId && !profileId) return null

  return (
    <AppLink
      href={process.env.NEXT_PUBLIC_FEATURE_UNSUBSCRIBE_EXTERNAL_LINK}
      target={'_blank'}
      size={AppLinkSize.S}
      internal={false}
    >
      {t('unsubscribeLink')}
    </AppLink>
  )
}